"use client";

import { useState } from "react";
import { cn } from "@/lib/utils";
import { Plus, Minus } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { FAQItemProps } from "./types";

export const FAQItem = ({ question, answer }: FAQItemProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-sm transition-all duration-300 hover:shadow-md">
      <div
        className="p-4 cursor-pointer flex justify-between items-center"
        onClick={toggleOpen}
      >
        <h3 className="text-secondary-gray font-medium pr-1">{question}</h3>
        <div
          className={cn(
            "min-w-6 min-h-6 flex items-center justify-center rounded-sm transition-colors duration-300",
            isOpen ? "bg-primary-aqua" : "bg-slate-100"
          )}
        >
          {isOpen ? (
            <Minus className="h-5 w-5 text-white" />
          ) : (
            <Plus className="h-5 w-5 text-slate-600" />
          )}
        </div>
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="px-4 pb-6 text-sm text-secondary-gray">
              {answer}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
